// Copyright (c) 2024 - Present. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { api } from '@/api/axios-instance';
import { parseResponse } from '@/api/parse-response';
import {
  BulkItemsInventoryResponse,
  InventoryFilters,
  UNPAGINATED_INVENTORY_LIMIT,
  bulkItemsInventoryResponseSchema,
} from '@/inventory/api/types';
import queryString from 'query-string';

/**
 * Gets bulk items inventory with optional filters
 *
 * Endpoint: GET /v1/inventory/bulk-items
 *
 * @param filters - Optional filters to apply to the bulk items inventory query
 * @returns Promise resolving to bulk items inventory response
 */
export async function getBulkItemsInventory(
  filters?: InventoryFilters
): Promise<BulkItemsInventoryResponse> {
  const url = '/v1/inventory/bulk-items';
  const response = await api.get(url, {
    paramsSerializer: (parameters) => queryString.stringify(parameters),
    params: { ...filters, limit: UNPAGINATED_INVENTORY_LIMIT },
  });
  return parseResponse(bulkItemsInventoryResponseSchema, response.data, {
    schemaName: 'BulkItemsInventory',
    endpoint: url,
  });
}
